module.exports = "<div class=\"col-md-4 col-xs-6 membership-card-directive {{ type }}\" ng-show=\"showAd()\">\n  <div class=\"background\">\n    <div class=\"message\">\n      <h2>More than just <br> nightclubs.</h2>\n      <p>Introducing Tablelist Membership</p>\n      <a class=\"btn btn-primary\" ng-click=\"goToMembership()\">Learn More</a>\n    </div>\n  </div>\n</div>\n";


//////////////////
// WEBPACK FOOTER
// ./src/directives/membershipCard/template.html
// module id = 858
// module chunks = 1